/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An enumeration.
 */
export enum AvailableRoles {
    MANIFEST_READER = 'manifest_reader',
    MANIFEST_WRITER = 'manifest_writer',
    CRUISE_ADDENDUM_MANIFEST_WRITER = 'cruise_addendum_manifest_writer',
    DATA_ASSET_READER = 'data_asset_reader',
    RESTRICTED_DATA_ASSET_READER = 'restricted_data_asset_reader',
    DATA_SET_CREATOR = 'data_set_creator',
    DATA_SET_READER = 'data_set_reader',
    REAL_ASSET_READER = 'real_asset_reader',
    REAL_ASSET_CREATOR = 'real_asset_creator',
    SHARING_LINK_CREATOR = 'sharing_link_creator',
    SHARING_LINK_ADMIN = 'sharing_link_admin',
}
